<template>
  <section>
    <div
      class="d-flex align-items-center"
      @click="isRunning ? stop() : start()" @keypress="isRunning ? stop() : start()" 
    >
      <!-- <img src="@/assets/icon_timer.svg" alt="" class="icon" /> -->
      <img src="@/assets/time-gray.png" alt="" class="w-14 h-14 mgr-2" />
      <span class="t-body3 t-color-quizBlack font-rn">{{ converthhmmss }}</span>
    </div>
  </section>
</template>

<script>
/**
 * 타이머 컴포넌트(timer component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
  props: ["time"],
  data() {
    return {
      isRunning: false,
      secondes: 0,
      timer: null,
    };
  },
  computed: {
    converthhmmss() {
      let myNum = parseInt(this.secondes, 10);
      let hours = Math.floor(myNum / 3600);
      let minutes = Math.floor((myNum - hours * 3600) / 60);
      let seconds = myNum - hours * 3600 - minutes * 60;

      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      // return hours+':'+minutes+':'+seconds;
      return minutes + ":" + seconds;
    },
  },
  mounted() {
    this.setTimeToSeconds(this.time);
    this.start();
  },
  methods: {
    start() {
      this.isRunning = true;
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (this.secondes > 0) {
            this.secondes--;
          } else {
            clearInterval(this.timer);
            // this.sound.play()
            this.reset();
            this.$emit("timerEnd");
          }
        }, 1000);
      }
      this.$emit("timerState", true);
    },
    stop() {
      this.isRunning = false;
      clearInterval(this.timer);
      this.timer = null;
      this.$emit("timerState", false);
    },
    reset() {
      this.stop();
      //this.secondes = 0
      this.setTimeToSeconds(this.time);
    },
    setTimeToSeconds(minutes) {
      this.secondes = minutes * 60;
    },
  },
};
</script>
<style scoped>
.bottom-timer img.icon{width: 14px; height: 14px; margin-right: 5px;}
html[dir="rtl"] .bottom-timer img.icon{width: 14px; height: 14px; margin-left: 5px;}
.bottom-timer span{color: var(--QuizBlack);}
</style>